import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "haven_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, auth());
  return data;
};

export const fetchBookings = async () => {
  const { data } = await axios.get(`${API}/admin/bookings`, auth());
  return data;
};

export const updateBookingStatus = async (id, status) => {
  const { data } = await axios.patch(`${API}/admin/bookings/${id}`, { status }, auth());
  return data;
};

export const deleteBooking = async (id) => {
  await axios.delete(`${API}/admin/bookings/${id}`, auth());
};
